module.exports = require('./helpers/bundle-url').getBundleURL('5GvXU') + "logo-dark.eefe0b7f.svg";